import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getSocket } from "../../helper/socket";

export const placeBet = createAsyncThunk(
    "placeBet/execute",
    async (betData, { rejectWithValue, dispatch }) => {
        return new Promise((resolve, reject) => {
            const socket = getSocket();
            try {
                socket.emit("placeBet", betData);

                socket.once("placed_bet", (response) => {
                    if (!response?.status) {
                        reject(rejectWithValue(response?.message || "Unknown error")); // ✅
                        return;
                    }
                    resolve(response);

                    socket.once("result", (resultData) => {
                        dispatch(updateBetResult(resultData));
                    });
                });

                setTimeout(() => reject(rejectWithValue("No response from server")), 5000);
            } catch (error) {
                reject(rejectWithValue(error.message));
            }
        });
    }
);

const placeBetSlice = createSlice({
    name: "placeBet",
    initialState: {
        data: null,
        result: null,
        loading: false,
        error: null,
    },
    reducers: {
        resetPlaceBet: () => ({
            data: null,
            result: null,
            loading: false,
            error: null,
        }),
        updateBetResult: (state, action) => {
            state.result = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(placeBet.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(placeBet.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(placeBet.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { resetPlaceBet, updateBetResult } = placeBetSlice.actions;
export default placeBetSlice.reducer;
